"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPageSectionDivider = exports.StyledPageSectionWrapper = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledPageSectionWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledPageSectionWrapper", componentId: "sc-enluhb" }) `
  ${(props) => (0, ui_1.mq)({
    paddingTop: props.hasTopSpacer ? (0, ui_1.getSpacerBreakpointValues)(props.theme, ['x6', null, 'x12']) : [],
    paddingBottom: [props.theme.spacers.x6, null, props.theme.spacers.x18],
})}
`;
exports.StyledPageSectionDivider = styled_components_1.default.div.withConfig({ displayName: "StyledPageSectionDivider", componentId: "sc-12c8bhr" }) `
  width: 100%;
  height: ${(props) => props.theme.spacers.x3};

  ${(props) => (0, ui_1.mq)({
    boxShadow: props.theme.shadows.quaternary,
})}
`;
